import React, { Component } from "react";

export default class NoData extends Component {
  render() {
    return <div>No Data</div>;
  }
}
